import { travelExplorerURL, travelExplorerURLV3 } from './apiDomain'
import { travelExplorerHttp } from './http'

// let client = travelExplorerHttp(travelExplorerURL);
// let clientV3 = travelExplorerHttp(travelExplorerURLV3);

export default {
    getDetailProfile(id) {
        const client = travelExplorerHttp(travelExplorerURL);
        return client.get(`/user/details/${id}`)
    },
    getConsortiums() {
        const client = travelExplorerHttp(travelExplorerURL);
        return client.get('/consortiums')
    },
    // avatar goes to the file service; the returned key is saved via account-settings (`photo`)
    uploadAvatarFile(data) {
        const clientTE = travelExplorerHttp('', false);
        return clientTE.post('/api/upload/v1/uploadMedia', data)
    },
    updateProfile(data) {
        const client = travelExplorerHttp(travelExplorerURL);
        return client.post('/account-settings', data)
    },
    updateProfileAgent(data) {
        const client = travelExplorerHttp(travelExplorerURL);
        return client.post('/travel-agent/account-settings', data)
    },
    resetPassword(data) {
        const client = travelExplorerHttp(travelExplorerURL);
        return client.post('/user/reset-password', data)
    },
    sendNotify(data) {
        const clientV3 = travelExplorerHttp(travelExplorerURLV3);
        return clientV3.post('push-slack-notify', data)
    },
    sendTrackingEngagement(data) {
        const clientV3 = travelExplorerHttp(travelExplorerURLV3);
        return clientV3.post('tracking-engagement', data)
    }
}
